// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4a793574","69":"45ef7828","128":"ef8ef2f9","279":"525a13f1","288":"3f31293a","295":"d069675c","490":"5c91e6e6","509":"e47cba18","578":"9efd8f19","584":"0efc7815","590":"7b1a402a","606":"6c60fa30","773":"3ebd835d","823":"1d21cf7f"}[chunkId] + ".chunk.js";
};